export default __webpack_public_path__ + "static/media/SolPhantoms-Logo.899cf747.svg";